import { HTTPMethod } from 'helpers/method';
import { ENDPOINT } from 'services/configs/endpoint.constant';

import {
  GetNotificationsFilterResponse,
  GetNotificationsResponse,
  NotificationFilterParams,
  NotificationSubscriptionRequest,
  NotificationSubscriptionResponse,
  TestPushNotificationRequest,
  TestPushNotificationResponse,
  VapidPublicKeyResponse,
} from './notification.type';
import { request } from '../configs/axiosConfig';

export const NotificationService = {
  getNotifications: async () => {
    return request<GetNotificationsResponse>({
      method: HTTPMethod.GET,
      url: ENDPOINT.GET_NOTIFICATION,
    });
  },
  markAsReadNotification: async () => {
    return request({ method: HTTPMethod.PUT, url: ENDPOINT.MARK_AS_READ_NOTIFICATION });
  },
  subscribeNotification: async (subscriptionData: NotificationSubscriptionRequest) => {
    return request<NotificationSubscriptionResponse>({
      method: HTTPMethod.POST,
      url: ENDPOINT.SUBSCRIBE_NOTIFICATION,
      data: subscriptionData,
    });
  },
  unsubscribeNotification: async (subscriptionId: string) => {
    return request({
      method: HTTPMethod.DELETE,
      url: `${ENDPOINT.UNSUBSCRIBE_NOTIFICATION}/${subscriptionId}`,
    });
  },
  testPushNotification: async (testData: TestPushNotificationRequest) => {
    return request<TestPushNotificationResponse>({
      method: HTTPMethod.POST,
      url: ENDPOINT.TEST_PUSH_NOTIFICATION,
      data: testData,
    });
  },
  getVapidPublicKey: async () => {
    return request<VapidPublicKeyResponse>({
      method: HTTPMethod.GET,
      url: ENDPOINT.GET_VAPID_PUBLIC_KEY,
    });
  },
  getNotificationsFilter: async (params: NotificationFilterParams) => {
    return request<GetNotificationsFilterResponse>({
      method: HTTPMethod.GET,
      url: ENDPOINT.GET_NOTIFICATIONS_FILTER,
      params,
    });
  },
  markAllAsRead: async () => {
    return request({
      method: HTTPMethod.POST,
      url: ENDPOINT.MARK_ALL_AS_READ_NOTIFICATION,
    });
  },
  getNotificationCount: async () => {
    return request({
      method: HTTPMethod.GET,
      url: ENDPOINT.GET_NOTIFICATION_COUNT,
    });
  },
};
